<template>
	<div v-loading="dataLoading">
		<tab name="1">{{formData && formData.id}} {{formData && formData.title}} <b
				v-if="formData && formData.haveEditAudit" class="color-danger">存在还未处理的演出修改审核，请处理后再编辑演出信息</b></tab>
		<el-form v-if="formData" :model="formData" :rules="rules" ref="formData" label-position="top"
			:disabled="formData && formData.haveEditAudit" size="medium">
			<el-row :gutter="30">
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item prop="poster" label="演出海报:">
						<image-upload :url.sync="formData.poster" :urlFull.sync="formData.poster"
							:original.sync="formData.posterOriginal" ref="posterUpload" class="poster-upload"
							fit="cover" @onSuccess="handleImageSuccess">
							<span slot="size">建议宽高比3:4,不小于1200*1600px</span>
						</image-upload>
						<div>
							<el-button icon="el-icon-download" @click="download" :loading="downLoading"
								size="mini">下载原图</el-button>
							<el-button v-if="$utils.have('/activity/addSoldOut')" icon="el-icon-collection-tag"
								size="mini" @click="addSoldOut" :loading="soldOutLoading">
								{{ formData.soldOut == 2 ? '去掉售罄标志' : '添加售罄标志'}}
							</el-button>
							<!-- <el-button v-if="formData.tourId && $utils.have('/activity/syncPoster')" icon="el-icon-refresh" size="mini" @click="$refs.activitySynsPoster.show()">同步至巡演其他演出</el-button> -->
						</div>
					</el-form-item>
					<el-form-item ref="imageItem" label="票面背景图:" prop="imageId">
						<div>
							<el-radio v-model="formData.imageType" :label="0" border size="medium">系统模板</el-radio>
							<el-radio v-model="formData.imageType" :label="1" border size="medium">指定背景图</el-radio>
						</div>
						<div v-if="formData.imageType === 1" class="MT10">
							<el-select v-model="formData.imageId" :filterable="true" placeholder="请选择">
								<el-option v-for="item in imageOptions" :key="item.value" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</div>
						<div class="image-tips MT10">票面背景图在 【系统设置】【图库管理】中管理。状态为「指定背景图」的背景图只会作为指定的演出票的背景使用</div>
					</el-form-item>
					<el-form-item prop="rendered" label="秀动呈献：">
						<el-checkbox v-model="formData.rendered" :true-label="1"
							:false-label="0">勾选后的演出,在演出列表标题会显示秀动呈献前缀</el-checkbox>
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item prop="activityChannel">
						<span slot="label">内容渠道: </span>
						<el-input v-model="formData.activityChannel" placeholder="请输入内容渠道" size="medium"
							disabled></el-input>
					</el-form-item>
					<el-form-item prop="sellMode">
						<span slot="label">售票模式: </span>
						<el-select v-model="formData.sellMode" placeholder="请选择售票模式" size="medium"
							:disabled="formData.canUpSellMode == true ? false : true">
							<el-option :value="1" label="不选座" :disabled="formData.canUpSellMode == true"></el-option>
							<el-option :value="3" label="随机选座"></el-option>
							<el-option :value="2" label="在线选座"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="showstartControlOrder"
						v-if="formData && formData.showstartControlOrder == 1 || formData.showstartControlOrder == 0">
						<span slot="label">下单控制逻辑: </span>
						<p v-if="formData.showstartControlOrder == 0 "><span class="color-danger">云仓控制</span> (下单, 售票时间,
							票品库存, 价格计算等全部由云仓控制)</p>
						<p v-if="formData.showstartControlOrder == 1 "><span class="color-danger">秀动控制</span> (下单, 售票,
							库存, 全部由秀动控制, 云仓信息同步停止, 所有信息都以秀动为准)</p>
					</el-form-item>
					<el-form-item prop="status" label="演出状态:">
						<el-select v-model="formData.status" placeholder="请选择演出状态" size="medium"
							:disabled="activityStattus != 4 && activityStattus != 5 ? true : false">
							<el-option :value="0" label="未提交" :disabled="true"></el-option>
							<el-option :value="1" label="待审核"
								:disabled="activityStattus != 5 ? true : false"></el-option>
							<el-option :value="2" label="预售中"
								:disabled="activityStattus != 4 ? true : false"></el-option>
							<el-option :value="3" label="已结束" :disabled="true"></el-option>
							<el-option :value="4" label="已取消"
								:disabled="activityStattus != 4 ? true : false"></el-option>
							<el-option :value="5" label="未通过"
								:disabled="activityStattus != 5 ? true : false"></el-option>
							<el-option :value="6" label="定时上架"
								:disabled="activityStattus != 6 ? true : false"></el-option>
						</el-select>
						<div v-if="formData.reason" class="el-form-item__error"><span class="el-icon-info"></span>
							原因:{{formData.reason}}</div>
					</el-form-item>
					<el-form-item prop="status" label="定时上架时间:" v-if="formData.status == 6">
						<el-date-picker v-model="formData.onlineTime" type="datetime" placeholder="请输入定时上架时间"
							value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm" size="small"
							style="width: 80%; margin-right: 20px;"></el-date-picker>
						<el-button type="success" size="small" @click="releaseNow()">立刻上架</el-button>
					</el-form-item>
					<el-form-item prop="showTypeTagId" label="活动类型:">
						<el-cascader v-model="formData.showTypeTagId" :options="showTypeTagList"
							:props="{value:'id',label:'name',children:'tags', emitPath:false}" placeholder="请选择活动类型"
							size="medium" style="width:100%" @change="showTypeTag" ref="cascaderAddr"></el-cascader>
					</el-form-item>
					<!-- <el-form-item prop="type" label="演出类型:">
                        <el-select v-model="formData.type" placeholder="请选择演出类型" size="medium">
                            <el-option :value="1" label="Livehouse"></el-option>
                            <el-option :value="2" label="音乐节"></el-option>
                            <el-option :value="3" label="剧场"></el-option>
                            <el-option :value="4" label="演唱会"></el-option>
                        </el-select>
                    </el-form-item> -->
					<!-- <el-form-item prop="siteTypeTagId" label="场地类型:">
                        <el-cascader v-model="formData.siteTypeTagId" :options="siteTypeTagList" :props="{value:'id',label:'name',children:'tags', emitPath:false}" placeholder="请选择场地类型" size="medium" style="width:100%"></el-cascader>
                    </el-form-item> -->
					<el-form-item prop="title">
						<span slot="label">演出名称: <small>当演出名称没有日期、城市、场地信息时无需补充，系统会自动生成</small></span>
						<el-input v-model.trim="formData.title" placeholder="请输入演出名称" maxlength="100"
							size="medium"></el-input>
					</el-form-item>
					<el-form-item prop="searchKeywords">
						<span slot="label">演出搜索关键词: <small>不同词之间用英文逗号隔开</small></span>
						<el-input v-model.trim="formData.searchKeywords" placeholder="输入关键词，不同词之间用英文逗号隔开"
							size="medium"></el-input>
					</el-form-item>
					<el-form-item v-if="formData.showTypeTagId === 1387" prop="musicFestival">
						<span slot="label">自有/合作音乐节:
							<small class="ML10">
								<span><el-checkbox v-model="formData.musicFestival" :true-label="1"
										:false-label="0">勾选后会标记为此类型的音乐节演出</el-checkbox></span>
							</small>
						</span>
					</el-form-item>
					<el-form-item
						v-if=" formData.showTypeTagId === 1379 || formData.showTypeTagId === 34 ||  formData.showTypeTagId === 1387  ||  formData.showTypeTagId === 1388 || formData.showTypeTagId === 1416 "
						prop="isCover">
						<span slot="label">翻唱演出:
							<small class="ML10">
								<span><el-checkbox v-model="formData.isCover" :true-label="1"
										:false-label="0">勾选后会标记为翻唱演出</el-checkbox></span>
							</small>
						</span>
					</el-form-item>					
					<el-form-item prop="isXr">
						<span slot="label">XR演出:
							<small class="ML10">
								<span><el-checkbox v-model="formData.isXr" :true-label="1"
										:false-label="0">勾选后会标记为XR项目演出</el-checkbox></span>
							</small>
						</span>
					</el-form-item>
					<el-form-item prop="hideShowTime">
						<span slot="label">C端隐藏场次时间:
							<small class="ML10">
								<span><el-checkbox v-model="formData.hideShowTime" :true-label="1"
										:false-label="0">勾选后会标记为C端隐藏场次时间</el-checkbox></span>
							</small>
						</span>
					</el-form-item>
				</el-col>
			</el-row>

			<div class="page-group-title"><span>阵容&风格</span></div>
			<el-row :gutter="30">
				<el-col :xs="24" :xl="16">
					<el-form-item prop="squadStatus" label="演出阵容:">
						<el-radio-group v-model="formData.squadStatus" size="medium">
							<el-radio :label="1">正常展示</el-radio>
							<el-radio :label="3">后续公布</el-radio>
							<el-radio :label="2">无(适用于不存在艺人的场景)</el-radio>
							<el-radio :label="4">按场次设置</el-radio>
						</el-radio-group>
						<el-table :data="formData.sessionShows" border style="width: 100%" size="small">
							<el-table-column prop="time" label="时间"></el-table-column>
							<el-table-column label="艺人">
								<template slot-scope="scope">
									<div class="performers-list">
										<vuedraggable v-model="formData.sessionShows[scope.$index].performers"
											:draggable="`.performers-item-${scope.$index}`">
											<el-tag type="info" effect="plain"
												v-for="(item,index) in scope.row.performers" :key="index"
												:class="`performers-item performers-item-${scope.$index}`">{{item.name}}<span
													:class="item.type == 1 ? 'color-danger' : '' ">({{item.type == 1 ? '艺人' : '嘉宾'}})</span></el-tag>
										</vuedraggable>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="按场次设置" v-if="formData.squadStatus == 4">
								<template slot-scope="scope">
									<el-radio-group v-model="formData.sessionShows[scope.$index].squadStatus"
										size="medium">
										<el-radio :label="1">正常展示</el-radio>
										<el-radio :label="3">后续公布</el-radio>
										<el-radio :label="2">无</el-radio>
									</el-radio-group>
								</template>
							</el-table-column>
						</el-table>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="30" v-if="showTypeText == '音乐会' || showTypeText == '音乐演出' ">
				<el-col :xs="24" :xl="16">
					<el-form-item prop="styleIds" label="演出风格:"
						:rules="[{type: 'array',required: activityStattus == 2 ? true : false, message: '请选择演出风格'}]">
						<el-checkbox-group v-model="formData.styleIds" size="medium" @change="selectStyes">
							<el-table :data="formData.styles" border style="width: 100%" size="small">
								<el-table-column label="风格&标签">
									<template slot-scope="scope">
										<el-checkbox :label="scope.row.styleId">
											{{scope.row.styleName}}{{scope.row.tagName ? '-'+scope.row.tagName : ''}}
										</el-checkbox>
									</template>
								</el-table-column>
								<el-table-column label="艺人">
									<template slot-scope="scope">
										<div class="performers-list">
											<el-tag type="info" effect="plain"
												v-for="(item,index) in scope.row.userName" :key="index"
												class="performers-item">{{item}}</el-tag>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</el-checkbox-group>
					</el-form-item>
				</el-col>
			</el-row>

			<div class="page-group-title"><span>歌曲</span></div>
			<el-row :gutter="30">
				<el-col :xs="24" :xl="16">
					<el-form-item prop="musicIds">
						<span slot="label">
							演出歌曲:
							<el-button icon="el-icon-circle-plus-outline" size="mini" type="primary" plain
								@click="$refs.selectMusic.show()">
								从曲库选择歌曲
							</el-button>
						</span>
						<small v-if="formData.musicIds.length > 0" class="color-warning">按住鼠标,可拖动排序</small>
						<!-- <el-checkbox-group v-model="musicIds" size="mini" @change="updateMusicId"> -->
						<el-row :gutter="20">
							<vuedraggable v-model="formData.musicIds" draggable=".dragItem" @change="updateMusicId">
								<span v-for="item in formData.musicIds" :key="item.TSID" class="dragItem">
									<!-- s<el-checkbox :label="item.TSID.toString()" >{{item.title}}</el-checkbox> -->
									<el-tag type="info" effect="plain">{{item.title}}</el-tag>
								</span>


							</vuedraggable>
						</el-row>
						<!-- </el-checkbox-group> -->
						<select-music v-if="formData && musicList" ref="selectMusic" :activityId="id"
							:musicIds.sync="formData.musicIds"></select-music>
					</el-form-item>
				</el-col>
			</el-row>

			<div class="page-group-title"><span>场地&主办&联系人</span></div>
			<el-row :gutter="30">
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item label="用户填写的场地:">
						<!-- {{formData.customSite && formData.customSite.name || '无自定义场地'}} -->
						<el-input placeholder="无自定义场地" disabled :value="formData.customSite && formData.customSite.name"
							size="medium"></el-input>
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item prop="siteId">
						<span slot="label">
							演出场地:
							<el-button size="mini" type="text" @click="addSite(formData.customSite)">点击创建场地</el-button>
						</span>
						<el-select v-model="formData.siteId" filterable remote placeholder="请输入演出场地"
							:remote-method="searchSite" :loading="userLoading" size="medium" @change="changeSite">
							<el-option v-for="item in siteList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="30" v-if="siteAddressDetail">
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item>
						<div>演出场地详细地址 : {{siteAddressDetail}}</div>
					</el-form-item>
				</el-col>
				<el-col  :xs="24" :sm="12" :xl="8" v-if="siteAuditRemark">
					<el-form-item>
						<div><span class="color-danger">场地特殊备注 : </span>{{siteAuditRemark}}</div>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="30">
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item prop="hostIds" label="演出主办:">
						<el-select v-model="formData.hostIds" filterable remote multiple placeholder="请输入演出主办"
							:remote-method="searchHost" :loading="userLoading" size="medium">
							<el-option v-for="item in hostList" :key="item.id"
								:label="`[${$userType.get(item.userType)}]${item.name}`" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item prop="undertakerIds" label="演出承办方:">
						<el-select v-model="formData.undertakerIds" filterable remote multiple placeholder="请输入演出承办方"
							:remote-method="searchUndertaker" :loading="userLoading" size="medium">
							<el-option v-for="item in undertakerList" :key="item.id"
								:label="`[${$userType.get(item.userType)}]${item.name}`" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="30">
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item prop="startUserId" label="演出发起人">
						<el-select v-model="formData.startUserId" filterable remote placeholder="请输入演出发起人"
							:remote-method="searchStartUser" :loading="userLoading" size="medium">
							<el-option v-for="item in startUserList" :key="item.id"
								:label="`[${$userType.get(item.userType)}]${item.name}`" :value="item.id">
							</el-option>
						</el-select>

					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item prop="principalId" label="项目负责人:">
						<el-select v-model="formData.principalId" filterable remote placeholder="请输入项目负责人"
							:remote-method="searchPrincipal" :loading="userLoading" size="medium">
							<el-option v-for="item in principalList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="30">
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item prop="contactsName" label="演出联系人">
						<el-input placeholder="请输入演出联系人" v-model="formData.contactsName" size="medium"></el-input>
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item prop="contactsTel" label="联系人手机">
						<el-input placeholder="请输入演出联系人手机号" v-model="formData.contactsTel" size="medium"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="30">
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item prop="contactsMail" label="联系人邮箱">
						<el-input placeholder="请输入演出联系人邮箱" v-model="formData.contactsMail" size="medium"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<div class="page-group-title"><span>简介</span></div>
			<el-row :gutter="30">
				<el-col :xs="24" :xl="16">
					<el-form-item prop="serviceTemplateId">
						<p slot="label">
							购票须知:（<span class="color-danger">红色模板为当前演出专用模板，其模板内容只在当前演出下展示，点击选项可以编辑模板内容</span>）
							<el-button type="primary" plain size="mini"
								@click="$refs.ActivitySyncTemplate.show('',formData.id)">创建专用模板</el-button>
						</p>
						<el-checkbox-group v-model="formData.serviceTemplateId" size="medium">
							<el-table :data="serviceTemplateList" border style="width: 100%" size="small"
								class="templateTable">
								<el-table-column label="一级分类" width="100px" prop="label">

								</el-table-column>

								<el-table-column label="二级分类" width="100px">

									<template slot-scope="{row} = scope">
										<ul>
											<li v-for="(item) in row.children" :key="item.value">{{item.label}}
												{{item.id}}</li>
										</ul>
										<!-- <span v-for="item in row.children" :key="item.value" class="MR20">
											{{item.label}}
										</span> -->
									</template>
								</el-table-column>
								<el-table-column label="模板">
									<template slot-scope="{row} = scope">
										<ul class="secondUl">
											<li v-for="(item,index) in row.children" :key="index" class="textLeft">
												<!-- <el-scrollbar style="whiteSpace:nowrap; width: 100%; height: 40px;"> -->
												<span v-for="item2 in item.children" :key="item2.id" class="MR20">
													<el-checkbox :label="item2.id.toString()">
														<span :class="{'color-danger': item2.bindIds}">{{item2.title}}
															[{{item2.id}}]</span>
													</el-checkbox>
													<el-popover width="400">
														<div v-html="item2.chineseContent"></div>
														<el-link slot="reference" type="info" :underline="false"
															style="vertical-align: baseline;"><span
																class="el-icon-question"></span></el-link>
													</el-popover>

													<el-button type="text" size="small" icon="el-icon-edit"
														v-if="item2.bindIds"
														@click="$refs.ActivitySyncTemplate.show(item2.id,item2.bindIds)">
													</el-button>
												</span>
												<!-- </el-scrollbar> -->
											</li>
										</ul>
									</template>
								</el-table-column>
							</el-table>
						</el-checkbox-group>
						<!-- <div class="MT15">
							<el-button type="primary" size="small"
								@click="$refs.ActivitySyncTemplate.show('',formData.id)">创建专用模板</el-button>
						</div> -->
					</el-form-item>
				</el-col>
				<el-col :xs="24" :xl="16">
					<el-form-item prop="document">
						<span slot="label">
							演出简介:
							<!-- <el-button 
                                v-if="formData.tourId && $utils.have('/activity/syncDesc')"
                                size="mini" 
                                type="primary"
                                plain
                                icon="el-icon-refresh"
                                @click="$refs.activitySynsDesc.show()"
                            >同步至巡演其他演出</el-button> -->
						</span>
						<tinymce v-model="formData.document" :height="500" :toolbar="toolbar" :menubar="false"
							v-if="reFresh"></tinymce>
					</el-form-item>
				</el-col>
			</el-row>

			<div class="page-group-title"><span>巡演&主题</span></div>
			<el-row :gutter="30">
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item label="演出所属巡演:">
						<el-link v-if="formData.tourId"
							:href="`${sswap}/pages/activity/list/list?type=1&tag=${formData.tourId}`"
							target="_blank">{{formData.tourName}}</el-link>
						<span v-else class="color-info">未绑定巡演</span>
						<!-- <el-input disabled :value="formData.tourName"></el-input> -->
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item label="演出所属主题:">
						<el-tag v-if="formData.themeName">{{formData.themeName}}</el-tag>
						<span v-else class="color-info">未绑定主题</span>
						<!-- <el-input disabled :value="formData.themeName"></el-input> -->
					</el-form-item>
				</el-col>
			</el-row>
			<el-row v-if="formData.tourId" :gutter="30">
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item prop="isSyncPoster" label="同步海报到该巡演其他演出:">
						<el-radio-group v-model="formData.isSyncPoster" size="medium">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item prop="isSyncDesc" label="同步演出简介到该巡演其他演出:">
						<el-radio-group v-model="formData.isSyncDesc" size="medium">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-col>
			</el-row>

		</el-form>
		<div class="page-group-title"></div>
		<el-alert v-if="formMessage" show-icon type="error" :title="formMessage" class="formMessage"
			:closable="false"></el-alert>
		<div class="clearfix PB20">
			<el-button @click="goBack">返回</el-button>
			<el-button v-if="$utils.have('/activity/refund/third') && formData && formData.showCancelThirdBtn == 1"
				@click="cancelThird" :loading="cancelthirdbtnLoading"
				:disabled="formData && formData.haveEditAudit">取消第三方订单</el-button>
			<el-button v-if="$utils.have('/activity/save')" type="primary" @click="onSubmitCheck(1)"
				:loading="btnLoading" :disabled="formData && formData.haveEditAudit">确认提交</el-button>
			<el-button v-if="$utils.have('/activity/save') && violate" type="primary" @click="onSubmit(0)"
				:loading="btnLoad2ing" :disabled="formData && formData.haveEditAudit">敏感词免检提交</el-button>
			<el-button
				v-if="$utils.have('/activity/order/control') && formData  && formData.showstartControlOrder === 0"
				type="primary" @click="dialogVisible=true" :loading="btnLoading3"
				:disabled="formData && formData.haveEditAudit">下单逻辑转为秀动控制</el-button>
			<el-button
				v-if="$utils.have('/activity/order/control') && formData && formData.showstartControlOrder && formData.showstartControlOrder == 1"
				type="primary" @click="dialogVisible=true" :loading="btnLoading4"
				:disabled="formData && formData.haveEditAudit">下单逻辑转为云仓控制</el-button>

			<!-- <el-button class="fr" type="danger"
                v-if="$utils.have('/activity/cancel') && (formData.status == 2 || formData.status == 3)" 
                @click="$refs.activityCancel.show()"
            >取消演出</el-button> -->
		</div>



		<template v-if="formData">
			<!-- 同步简介 -->
			<!-- <activity-sync-desc ref="activitySynsDesc" :formData="formData"></activity-sync-desc> -->
			<!-- 同步海报 -->
			<!-- <activity-sync-poster ref="activitySynsPoster" :formData="formData"></activity-sync-poster> -->
			<!-- 取消演出 -->
			<activity-cancel ref="activityCancel" :activity="formData" @onUpdate="getDataDetail()"></activity-cancel>
			<activity-sync-template ref="ActivitySyncTemplate" @onUpdate="getTemplate()" :activityId="id"
				v-if="formData && serviceTemplate"></activity-sync-template>
			<!-- <select-music v-if="formData && musicList" ref="selectMusic" :activityId="id"  :musicIds.sync="formData.musicIds"></select-music> -->

		</template>

		<!-- 新建场地 -->
		<site-add ref="siteAdd" @onUpdate="updateSiteList" @bindSite="bindSite"></site-add>

		<el-dialog :title="formData && formData.showstartControlOrder == 1 ? '下单逻辑转为云仓控制' : '下单逻辑转为秀动控制' "
			:visible.sync="dialogVisible" width="600px">
			<div class="dialog-content">
				<template v-if="formData && formData.showstartControlOrder == 0">
					下单逻辑转为秀动控制, 可简单看做演出直接在秀动创建
					<p class="MT20">1. "秀动控制"主要针对特别热门的云仓演出, 避免云仓服务导致秀动本身服务不稳定, 比如乒超项目<br>2. 云仓演出同步将会停止,
						演出所有信息秀动都可以编辑<br>3. <span class="color-danger">票品和库存</span>需要秀动自己来编辑和维护<br>4. <span
							class="color-danger">云仓销售策略将失效</span><br>5. 订单信息会同步给云仓, 订单取消云仓也会同步取消<br>6.支持候补, 定时购,
						推第三方渠道等功能</p>
				</template>
				<template v-if="formData && formData.showstartControlOrder == 1">
					下单逻辑转为"云仓控制"
					<p class="MT20">1. 云仓演出同步将会继续, 一些核心字段(尤其票品相关)无法编辑<br><span class="color-danger">2. 票品, 库存,
							将由云仓端控制</span><br>3. 未成功候补订单会失败<br>4. 推送的第三方渠道会下架</p>
				</template>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible=false">取 消</el-button>
				<el-button type="primary" @click="showstartControl(1)"
					v-if="formData && formData.showstartControlOrder == 0" :loading="showstartControlBtn">确
					定</el-button>
				<el-button type="primary" @click="showstartControl(0)"
					v-if="formData && formData.showstartControlOrder == 1" :loading="showstartControlBtn">确
					定</el-button>
			</span>
		</el-dialog>



		<el-dialog title="修改演出发起人提醒" :visible.sync="dialogVisible2" width="70%"
			v-if="initiatorData && initiatorData.receivablesAudiList">
			<div class="dialog-content">
				<p class="color-warning"><span class="el-icon-warning"></span> 你修改了演出发起人，这会影响演出结算，需要先飞书联系李娜娜，对以下结算单做处理
				</p>
				<el-table :data="initiatorData.receivablesAudiList" border style="width: 100%" class="MT20" size="small"
					stripe>
					<el-table-column prop="id" label="结款单ID"></el-table-column>
					<el-table-column prop="settlementSession" label="结款场次" min-width="300" show-overflow-tooltip>
						<template slot-scope="scope">
							<div v-if="scope.row.settlementSession" class="session-list">
								<div v-for="(item, idx) in splitSessions(scope.row.settlementSession)" :key="idx"
									class="session-item">
									{{ item }}
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="settlementStatus" label="结款单状态" min-width="90"></el-table-column>
					<el-table-column label="结算单时间" width="260">
						<template slot-scope="scope">
							<p v-if="scope.row.createTime">申请打款时间：{{scope.row.createTime}}</p>
							<p v-if="scope.row.playTime">实际打款时间：{{scope.row.playTime}}</p>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible2=false">取 消</el-button>
				<el-button type="primary" @click="onSubmit(1)" :loading="dialogVisible2Btn">已联系，确认修改</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import ImageUpload from '@/components/ImageUpload';
	import Tab from '../components/tab';
	import vuedraggable from 'vuedraggable';
	import SelectMusic from './components/select-music';
	import {
		fetchUser,
		downloadFile
	} from '@/assets/js/commonApi';
	import Tinymce from '@/components/Tinymce';
	import ActivityCancel from './components/activity-cancel';
	import ActivitySyncTemplate from './components/activity-sync-template';
	// import ActivitySyncPoster from './components/activity-sync-poster';
	// import ActivitySyncDesc from './components/activity-sync-desc';
	import SiteAdd from '@/components/SiteAdd';
	import {
		fetchServiceTemplateType
	} from '@/assets/js/commonApi'
	export default {
		props: {
			id: {
				type: [Number, String],
				default: () => null
			}
		},
		components: {
			Tab,
			ImageUpload,
			vuedraggable,
			SelectMusic,
			Tinymce,
			ActivityCancel,
			SiteAdd,
			ActivitySyncTemplate
		},
		data() {
			return {
				formData: null,
				rules: {
					poster: [{
						required: true,
						message: "请上传演出海报"
					}],
					imageId: {
						required: true,
						validator: (rule, value, callback) => {
							if (this.formData.imageType === 1 && !value) {
								return callback(new Error('请选择票面背景图'));
							}

							callback();
						}
					},
					title: [{
						required: true,
						message: "请输入演出名称"
					}],
					siteId: [{
						required: true,
						message: "请选择演出场地"
					}],
					startUserId: [{
						required: true,
						message: "请选择演出发起人"
					}],
					principalId: [{
						required: true,
						message: "请选择项目负责人"
					}],
					contactsTel: [{
						validator: this.$utils.validatePhone
					}],
					contactsMail: [{
						type: "email",
						message: "请输入正确的邮箱地址"
					}],
					document: [{
						required: true,
						message: "请输入演出简介"
					}],
					showTypeTagId: [{
						required: true,
						message: '请选择活动类型'
					}],
					// siteTypeTagId: [{required: true, message: '请选择场地类型'}],
				},
				dataLoading: false,
				btnLoading: false,
				btnLoad2ing: false,
				btnLoading3: false,
				btnLoading4: false,
				downLoading: false,
				soldOutLoading: false,
				cancelthirdbtnLoading: false,
				redirect: this.$route.query.redirect || '/activityManage/activity/list',
				userLoading: false,
				musicList: [], //音乐歌曲集合(临时)
				siteList: [], //场地集合(临时)
				hostList: [], //主办方集合(临时)
				undertakerList: [],
				startUserList: [], //演出发起人集合(临时)
				principalList: [], //项目负责人集合(临时)
				reFresh: false,
				toolbar: [
					'formatselect fontsizeselect | forecolor bold strikethrough | alignleft aligncenter alignright alignjustify | image | preview fullscreen'
				],
				oldSiteId: '',
				sswap: process.env.VUE_APP_SSWAP_URL,
				// stylesList:[], //风格集合 ,
				// stylesVo:[],
				formMessage: '',
				activityStattus: '',
				showTypeTagList: [],
				imageOptions: [],
				// siteTypeTagList:[],
				musicIds: [],
				serviceTemplateType: [],
				serviceTemplate: null,
				serviceTemplateList: [],
				violate: false,
				showTypeText: '',
				dialogVisible: false,
				dialogVisible2: false,
				dialogVisible2Btn: false,
				initiatorData: null,
				showstartControlBtn: false,
				siteAddressDetail: '',
				siteAuditRemark:''
			}
		},
		watch: {
			'formData.imageType': function(v) {
				if (v === 0) {
					this.formData.imageId = null;
				}

				this.$refs.imageItem?.clearValidate();
			}
		},
		async created() {
			// await this.getSiteTypeTag();
			if (this.id) {
				this.getDataDetail();
			}
			this.serviceTemplateType = await fetchServiceTemplateType();
			this.getTemplate();
			this.getShowTypeTag();
			this.getImageOptions();



		},
		methods: {
			//获取服务模板
			getTemplate() {
				this.serviceTemplateList = [];
				this.$request({
					url: "/activity/getTemplate",
					params: {
						activityId: this.id
					},
					method: "post",
				}).then(res => {
					const {
						state,
						result,
						msg
					} = res.data;
					if (state == 1 && result) {
						this.serviceTemplate = result
						var level1List = [{
							value: 1,
							label: '服务说明'
						}, {
							value: 2,
							label: '购票须知'
						}, {
							value: 3,
							label: '观演须知'
						}];
						var newLevel = [];
						for (let key1 in this.serviceTemplate) {
							//console.log("key1",key1);
							var level1 = JSON.parse(JSON.stringify(level1List.find(v => v.value == key1)));
							level1.children = []
							for (let key2 in this.serviceTemplate[key1]) {
								var level2 = JSON.parse(JSON.stringify(this.serviceTemplateType.find(v => v
									.value == key2)));

								level2.children = this.serviceTemplate[key1][key2]
								level1.children.push(level2)


							}
							newLevel.push(level1)
						}

						this.serviceTemplateList = newLevel

					} else {
						this.$message.error(msg && "获取购票须知失败");
					}
				})
			},
			//获取活动类型
			getShowTypeTag() {
				this.$request({
					url: "/styleTag/showType/all",
					method: "post",
					params: {
						id: this.id
					}
				}).then(res => {
					const {
						state,
						result
					} = res.data;
					if (state == 1) {
						this.showTypeTagList = result || []

					}
				})
			},
			showTypeTag() {
				const regionText = this.$refs['cascaderAddr'].getCheckedNodes()[0]?.pathLabels || []
				this.showTypeText = regionText[0]?.toString() || ''
			},
			changeSite(val){
				console.log(val)
				const selected = this.siteList.find(item => item.id === val);
				this.siteAuditRemark = selected.auditRemark
			},
			//获取场地类型
			// getSiteTypeTag(){
			//     this.$request({
			//         url: "/styleTag/showType/site/all",
			//         method: "post",
			//     }).then(res => {
			//         const { state, result } = res.data;
			//         if(state == 1){
			//             this.siteTypeTagList = this.siteTypeTagList.concat([...result])
			//         }
			//     }) 
			// },
			getImageOptions() {
				this.$request({
					url: "/activity/imageList",
					method: "post"
				}).then(res => {
					const {
						state,
						result
					} = res.data;
					if (state == 1) {
						this.imageOptions = (result || []).map(item => {
							const {
								id,
								imgName
							} = item;
							return {
								label: imgName,
								value: id
							}
						});
					}
				})
			},
			//获取详情
			getDataDetail() {
				this.dataLoading = true;
				this.$request({
						url: "/activity/info",
						params: {
							activityId: parseInt(this.id)
						},
						method: "post",
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1) {
							this.activityStattus = result.status;

							this.formData = {
								imageId: null,
								...result,
								musicIds: result.musics || [],
								siteId: result.siteInfo && result.siteInfo.id || '',
								hostIds: result.brandInfos.map(v => {
									return v.id
								}) || [],
								undertakerIds: result.undertaker.map(v => {
									return v.id
								}) || [],
								startUserId: result.startUser && result.startUser.id || '',
								principalId: result.principal && result.principal.id || '',
								rendered: result.rendered ? result.rendered : 0,
								isChooseMusic: 0,
								isSyncPoster: 0,
								isSyncDesc: 0,
								// siteTypeTagId: result.siteTypeTag && result.siteTypeTag.id || '',
								serviceTemplateId: result.serviceTemplateId && result.serviceTemplateId.split(
									',') || [],
								styleIds: [],
								activityChannel: result.activityChannel || '秀动自营',
								posterOriginal: result.posterOriginal || '',
							};
							this.musicList = result.musics ? [...result.musics] : [];
							this.musicIds = result.musics ? [...result.musics] : [];
							this.siteList = result.siteInfo ? [{
								...result.siteInfo
							}] : [];
							this.hostList = result.brandInfos ? [...result.brandInfos] : [];
							this.undertakerList = result.undertaker ? [...result.undertaker] : [];
							this.startUserList = result.startUser ? [{
								...result.startUser
							}] : [];
							this.principalList = result.principal ? [{
								...result.principal,
								name: result.principal.name
							}] : [];
							this.reFresh = true;
							this.oldSiteId = this.formData.siteId; 
							this.siteAuditRemark = result.siteInfo && result.siteInfo.auditRemark ? result.siteInfo.auditRemark : ''
							this.siteAddressDetail = result.siteInfo && result.siteInfo.address ? result.siteInfo
								.address : result.customSite && result.customSite.address ? result.customSite.address :
								''
							//this.stylesList = this.formData.styles || []; //风格
							// this.stylesList = [];
							this.formData.styles.forEach(item => {
								if (item.selected == 1) {
									this.formData.styleIds.push(item.styleId);
								}
							})
							this.selectStyes();
							this.$nextTick(() => {
								this.showTypeTag()
							})

							//this.updateMusicId();
							// if(result.siteTypeTag && !this.siteTypeTagList.find(item => item.id === result.siteTypeTag.id)){
							//     this.siteTypeTagList.push(result.siteTypeTag);
							// }


						} else {
							this.$message.error(msg || "获取演出失败,请重试");
						}
					})
					// .catch(() => {
					//     this.$message.error("获取演出失败,请重试ddd");
					// })
					.finally(() => {
						this.dataLoading = false;
					});
			},
			//图片上传成功后执行 需要重置海报的水印图
			handleImageSuccess() {
				if (this.formData.poster) {
					this.formData.posterWithNoWater = this.formData.poster;
					this.formData.posterOriginal = this.formData.poster.replace(/^https?:\/\/[^/]+/, '');
					this.formData.soldOut = 1;
					this.$refs["formData"].clearValidate('poster');
				}
			},
			//更新音乐ID
			async updateMusicId() {

				this.musicList = this.formData.musicIds

			},
			// 搜索场地
			searchSite(query) {
				this.searchUser(query, 3, 'siteList');
			},
			// 主办方搜索
			searchHost(query) {
				this.searchUser(query, -1, 'hostList');
			},
			// 承办方搜索
			searchUndertaker(query) {
				this.searchUser(query, -1, 'undertakerList');
			},
			// 演出发起人搜索
			searchStartUser(query) {
				this.searchUser(query, -1, 'startUserList');
			},
			// 项目负责人搜索
			async searchPrincipal(query) {
				if (query !== "") {
					this.userLoading = true;
					const res = await this.$request({
						url: '/adminUser/list',
						method: 'POST',
						params: {
							keyword: query
						}
					}).finally(() => {
						this.userLoading = false;
					});

					const {
						state,
						result
					} = res.data;

					if (state == 1 && result) {
						this.principalList = result;
					}
				}
			},
			// 搜索用户
			async searchUser(query, userType, obj) {
				if (query !== "") {
					this.userLoading = true;
					const res = await fetchUser({
						queryValue: query,
						userType: userType,
					}).finally(() => {
						this.userLoading = false;
					});

					const {
						state,
						result
					} = res.data;

					if (state == 1 && result) {
						this[obj] = result;
					}
				}
			},
			//取消第三方订单
			cancelThird() {
				this.cancelthirdbtnLoading = true;
				this.$request({
						url: "/activity/refund/third",
						method: "post",
						params: {
							activityId: parseInt(this.id)
						},
					})
					.then((res) => {
						//处理成功回调
						const {
							state,
							msg
						} = res.data;
						if (state && state == 1) {
							this.$message.success('取消成功');

						} else {
							return this.$message.error(msg || "操作失败");
						}
					})
					.finally(() => {
						this.cancelthirdbtnLoading = false;
					});
			},
			selectStyes() {
				const _tags = [];
				this.formData.styles.map(item => {
					if (this.formData.styleIds.find(val => val == item.styleId)) {
						// item.selected = 1
						if (item.tagId) {
							_tags.push(item.tagId)
						}
					} else {
						// item.selected = 0
					}
				})
				// const _styles = [], _tags = [];
				// this.stylesVo.forEach( item => {
				//     if(item.styleId){
				//         _styles.push(item.styleId)
				//     }
				//     if(item.tagId){
				//         _tags.push(item.tagId)
				//     }
				// })
				// this.formData.styles = _styles ? [...new Set(_styles)] : [];
				this.formData.tags = _tags ? [...new Set(_tags)] : [];
			},
			showstartControl(type) {
				var _type = type
				this.showstartControlBtn = true
				if (_type == 1) {
					this.btnLoading3 = true;
				} else {
					this.btnLoading4 = true;
				}
				this.$request({
						url: "/activity/order/control",
						method: "POST",
						params: {
							activityId: this.formData.id,
							isShowstartControlOrder: _type
						},
					})
					.then((res) => {
						//处理成功回调
						const {
							state,
							msg,
							result
						} = res.data;
						if (state && state == 1) {
							this.$message.success("操作成功");
							this.getDataDetail()
							this.dialogVisible = false
						} else {
							return this.$message.error(msg || "操作失败");
						}
					})
					.finally(() => {
						this.showstartControlBtn = false
						if (_type == 1) {
							this.btnLoading3 = false;
						} else {
							this.btnLoading4 = false;
						}
					});
			},
			splitSessions(sessionStr) {
				if (!sessionStr) return [];
				return sessionStr.split(/[,，]+/).map(s => s.trim()).filter(s => s);
			},
			//表单提交前验证
			onSubmitCheck(type) {
				var _type = type

				if (this.formData.status == 6) {
					if (this.formData.onlineTime && this.formData.onlineTime != '' && new Date(this.formData.onlineTime
							.replace(/-/g, "/")).getTime() < new Date().getTime()) {
						return this.$message.error('定时上架时间必须大于当前时间！');
					}
					if (this.formData.onlineTime && this.formData.onlineTime != '' && new Date(this.formData.onlineTime
							.replace(/-/g, "/")).getTime() > new Date(this.formData.minStartTime.replace(/-/g, "/"))
						.getTime()) {
						return this.$message.error('定时上架时间必须小于演出首场开演时间！');
					}

				}
				this.$request({
						url: "/activity/settlement/edit/check",
						method: "POST",
						data: {
							activityId: this.formData.id,
							data: {
								...this.formData,
								isCheckWord: type == 1 ? 1 : 0,
								serviceTemplateId: this.formData.serviceTemplateId.toString(),
								performerTOS: this.formData.sessionShows.map(item => {
									let _performers = [];
									item.performers && item.performers.map((v, i) =>
										_performers.push({
											...v,
											sort: i + 1,

										})
									);
									return {
										sessionId: item.sessionId,
										squadStatus: item.squadStatus,
										// performerIds: item.performers && item.performers.length > 0 ? item.performers.map(v => v.id) : []
										performerInfos: [..._performers]
									}
								}),
								styles: this.formData.styleIds,
								searchKeywords: this.formData?.searchKeywords?.replace(/，/g, ','),
								onlineTime: this.formData.status == 6 ? this.formData.onlineTime : ''
							},
							type: 1
						},
					})
					.then((res) => {
						//处理成功回调
						const {
							state,
							result
						} = res.data;
						if (state && state == 1) {
							if (result.needRemind) {
								this.initiatorData = result
								this.dialogVisible2 = true
							} else {
								this.onSubmit(_type)
							}
						}
					})

			},
			//表单提交
			onSubmit(type) {
				this.formData.isChooseMusic = this.formData.musicIds.length > 0 ? 1 : 0; //是否有改动

				this.$refs["formData"].validate((valid, label) => {
					if (valid) {
						if (type == 1) {
							this.btnLoading = true;
						} else {
							this.btnLoad2ing = true;
						}

						this.formMessage = "";
						console.log(this.formData.sessionShows)

						this.$request({
								url: "/activity/save",
								method: "POST",
								data: {
									...this.formData,
									isCheckWord: type == 1 ? 1 : 0,
									serviceTemplateId: this.formData.serviceTemplateId.toString(),
									performerTOS: this.formData.sessionShows.map(item => {
										let _performers = [];
										item.performers && item.performers.map((v, i) =>
											_performers.push({
												...v,
												sort: i + 1,

											})
										);
										return {
											sessionId: item.sessionId,
											squadStatus: item.squadStatus,
											// performerIds: item.performers && item.performers.length > 0 ? item.performers.map(v => v.id) : []
											performerInfos: [..._performers]
										}
									}),
									styles: this.formData.styleIds,
									searchKeywords: this.formData?.searchKeywords?.replace(/，/g, ','),
									onlineTime: this.formData.status == 6 ? this.formData.onlineTime : ''
								},
							})
							.then((res) => {
								//处理成功回调
								const {
									state,
									msg,
									result
								} = res.data;
								if (result && result != '') {
									this.violate = true
									return this.$message.error(result || "操作失败");

								} else {
									if (state && state == 1) {
										if (this.oldSiteId != this.formData.siteId) {
											this.pushChange()
										} else {
											// this.goBack();
											this.$confirm('是否返回列表', '操作成功', {
												type: 'success',
												center: true,
												confirmButtonText: '返回列表',
												cancelButtonText: '留在当前页面',
												closeOnClickModal: false
											}).then(() => {
												this.violate = false
												this.goBack();
											}).catch(() => {
												this.violate = false
												this.getDataDetail();
												this.dialogVisible2 = false
											})
										}
									} else {
										return this.$message.error(msg || "操作失败");
									}
								}

							})
							.finally(() => {
								if (type == 1) {
									this.btnLoading = false;
								} else {
									this.btnLoad2ing = false;
								}
							});
					} else {
						let keys = Object.keys(label)
						this.formMessage = label[keys[0]][0].message;
					}
				});
			},
			pushChange() {
				this.$confirm('此次提交修改了演出场地，是否需要告知用户？', '提示', {
					type: 'warning',
					center: true
				}).then(() => {
					// this.goBack();
					this.$confirm('操作成功', '提示', {
						type: 'success',
						center: true,
						confirmButtonText: '返回上一页',
						cancelButtonText: '留在当前页面',
						closeOnClickModal: false
					}).then(() => {
						this.goBack();
					}).catch(() => {
						this.getDataDetail();
					})
				}).catch(() => {})
			},
			//返回
			goBack() {
				if (this.redirect) {
					this.$router.push({
						path: this.redirect,
					});
				} else {
					this.$router.go(-1);
				}
			},

			//下载原图
			async download() {
				const _img = this.formData.posterOriginal;
				if (!_img) {
					return this.$message.error('海报原图不存在');
				}
				this.downLoading = true;
				await downloadFile(_img, this.formData.id + '海报原图.' + this.$utils.getFileType(_img));
				this.downLoading = false;
			},
			// 添加、去除海报售罄标识
			addSoldOut() {
				if (this.formData.soldOut == 1) {
					this.soldOutLoading = true;
					this.$request({
							url: "/activity/addSoldOut",
							method: "POST",
							params: {
								activityId: this.formData.id,
								poster: this.formData.poster
							},
						})
						.then((res) => {
							//处理成功回调
							const {
								state,
								msg,
								result
							} = res.data;
							if (state && state == 1) {
								this.formData.poster = result.urlFull;
								this.formData.soldOut = 2;
							} else {
								return this.$message.error(msg || "操作失败");
							}
						})
						.finally(() => {
							this.soldOutLoading = false;
						});
				} else {
					this.formData.poster = this.formData.posterWithNoWater
					this.formData.soldOut = 1;
				}
			},
			//添加场地
			addSite(data) {
				this.$refs.siteAdd.show(data);
			},
			//更新场地列表
			updateSiteList(data) {
				this.siteList = [{
					...data
				}];
				this.formData.siteId = data.id;
			},
			//立刻上架
			releaseNow() {

				this.$confirm('是否确认立刻上架？', '立刻上架', {
					closeOnClickModal: false
				}).then(() => {
					this.$request({
							url: "/activity/onlineAudit/online",
							params: {
								activityId: this.formData.id
							},
							method: "post",
						})
						.then((res) => {
							const {
								state,
								msg
							} = res.data;
							if (state == 1) {
								this.$message.success('立刻上架成功！');
								this.getDataDetail()
							} else {
								this.$message.error(msg || "操作失败,请重试");
							}
						})
						.catch(() => {
							this.$message.error("操作失败,请重试");
						})
				}).catch(() => {})

			},
			//绑定场地
			bindSite(data) {
				this.formData.siteId = data.id;
				this.siteList = [{
					...data
				}];
			}
		}
	}
</script>

<style lang="scss" scoped>
	.image-tips {
		line-height: 22px;
		color: #F56C6C;
	}

	.poster-upload {
		::v-deep .image {
			width: 180px;
			height: 240px;

		}

		::v-deep .image-upload-content {
			height: 240px;
		}
	}

	.el-table {
		margin-top: 10px;
	}

	::v-deep .custom-dialog {
		max-width: 600px;
	}

	.page-group-title {
		margin: 0px -20px;
		border-top: 5px solid #f8f8f8;
		padding: 20px;
	}

	.formMessage {
		margin-bottom: 20px;
	}

	.performers-list {
		.performers-item {
			margin: 2px;
			cursor: move;
		}
	}

	.dragItem {
		margin-right: 30px;
		display: inline-block;
	}

	.serviceTemplateList {
		display: flex;
		flex-wrap: wrap;

		>span {
			margin: 5px 20px 5px 0;
		}
	}

	.pointer {
		cursor: pointer;
	}

	.secondUl {
		>li {
			// height: 40px;
			line-height: 40px;
			text-align: center;

			border-bottom: 1px solid #eee;

			&.textLeft {
				text-align: left;
				// padding-left: 20px;
			}

			&:last-child {
				border-bottom: none;
			}

			span {
				white-space: nowrap;
			}
		}
	}

	::v-deep .el-form-item__label {
		line-height: 20px;
	}

	::v-deep .el-form-item {
		margin-bottom: 10px;
	}

	// ::v-deep .templateTable .cell{
	// 	padding:0;
	// 	margin:-10px 0;
	// 	text-align: center;
	// }

	// ::v-deep ::-webkit-scrollbar-track{
	// 	background: #eee;
	// }
	// ::v-deep ::-webkit-scrollbar {
	// 	height: 1px;
	// 	width: 1px;
	// }
	// ::v-deep ::-webkit-scrollbar-thumb{
	// 	background: #1fbb7d;
	// 	height: 1px;
	// }
</style>